<section class="edit-bill">
  <header>
    <h3>Solicitud de factura</h3>
  </header>

  <ng-template #stdField let-field_label="label" let-field_formname="formname", let-required="required">
    <mat-form-field class="fcontrol full-width" no_appearance="fill">
      <mat-label>{{field_label}}</mat-label>
      @let control = $any(form_billing.get!(field_formname));
      <input matInput
        [placeholder]="field_label" 
        [attr.i18n-placeholder]="'@@' + field_label + 'Placeholder'"
        [formControl]="control">
      @if (required) {
        @if (control.touched && (control.errors && control.errors!.required)) {
          <mat-hint class="error-text">
            <span i18n="@@web-inscripciones.obligatorio">Obligatorio</span>
          </mat-hint>
        }
      }
    </mat-form-field>
  </ng-template>
  <ng-template #emailField let-field_label="label" let-field_formname="formname" let-required="required">
    <mat-form-field class="fcontrol full-width" no_appearance="fill">
      <mat-label>{{field_label}}</mat-label>
      @let control = $any(form_billing.get!(field_formname));
      <input matInput
        [placeholder]="field_label" 
        [attr.i18n-placeholder]="'@@' + field_label + 'Placeholder'"
        [formControl]="control">
      @if (required) {
        @if (control.touched && (control.errors && control.errors!.required)) {
          <mat-hint class="error-text">
            <span i18n="@@web-inscripciones.obligatorio">Obligatorio</span>
          </mat-hint>
        }
      }
      @if (control.touched && (control.errors && control.errors!.pattern)) {
        <mat-hint class="error-text">
          <span i18n>eMail no válido</span>
        </mat-hint>
      }
    </mat-form-field>
  </ng-template>

  <form [formGroup]="form_billing" class="full-width">
    <ul>
      <li class="double">
        <div class="column-left">
          <ng-container *ngTemplateOutlet="stdField;context:{label: 'Razón social', formname: 'razon_social', required: true}"></ng-container><br />
        </div>

        <div class="column-right">
          <ng-container *ngTemplateOutlet="stdField;context:{label: 'NIF', formname: 'nif', required: true}"></ng-container><br />
        </div>
      </li>
      <li class="double">
        <div class="column-left">
          <ng-container *ngTemplateOutlet="stdField;context:{label: 'Código Postal', formname: 'codigo_postal', required: true}"></ng-container><br />
        </div>

        <div class="column-right">
          <ng-container *ngTemplateOutlet="stdField;context:{label: 'Dirección', formname: 'direccion', required: true}"></ng-container><br />
        </div>
      </li>
      <li class="">
        <div class="full-width">
          <ng-container *ngTemplateOutlet="stdField;context:{label: 'Persona contacto', formname: 'persona', required: true}"></ng-container><br />
        </div>
      </li>
      <li class="double">
        <div class="column-left">
          <ng-container *ngTemplateOutlet="stdField;context:{label: 'Teléfono contacto', formname: 'telefono', required: true}"></ng-container><br />
        </div>

        <div class="column-right">
          <ng-container *ngTemplateOutlet="emailField;context:{label: 'eMail', formname: 'email', required: true}"></ng-container><br />
        </div>
      </li>
    </ul>
    <nav mat-dialog-actions class="send-cancel-btns">
      <button mat-raised-button color="warn" (click)="close()">Cancelar</button>
      <button mat-raised-button color="primary" [btnLoading]="sending_data"
        [disabled]="form_billing.status==='INVALID'" (click)="sendInfoFactura()"
      cdkFocusInitial>Enviar</button>
    </nav>

  </form>

  @if (send_data_error_msg) {
    <div  class="error msg-send-factura">
      <mat-icon class="msg-error-close-btn" (click)="send_data_error_msg=''">cancel</mat-icon>
      Se ha producido un error enviando sus datos de facturación.<br />
      Por favor, intentelo de nuevo en unos momentos.<br />
      Gracias.
      <p class="msg-recibido">{{send_data_error_msg}}</p>
    </div>
  }

</section>
